var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-label"},[_c('span',[_c('Radio',{on:{"on-change":_vm.radioBoxClick},model:{value:(_vm.radioValueTemp),callback:function ($$v) {_vm.radioValueTemp=$$v},expression:"radioValueTemp"}},[_vm._v(_vm._s(_vm.item.label)+"：")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/formVue/commponents/go-label-radio.vue